// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ewdGp","icon":"styles_icon__Onixy","header":"styles_header__bt19S"};